export const INTEREST_RATE = {
  YEAR_1: 12,
  MONTHS_18: 18,
  MONTHS_1: 1,
};
